import { useMemo } from 'react';

export const translations = {
  vi: {
    settings: "Cài đặt",
    profile: "Hồ sơ",
    password: "Mật khẩu",
    notifications: "Thông báo",
    appearance: "Giao diện",
    language: "Ngôn ngữ",
    save: "Lưu thông tin",
    saving: "Đang lưu...",
    update_success: "Cập nhật thành công!",
    analyze_now: "Phân tích ngay",
    analyzing: "Đang phân tích...",
    excellent: "XUẤT SẮC",
    stable: "ỔN ĐỊNH",
    caution: "CẦN LƯU Ý",
    ai_verified: "XÁC MINH BỞI AI",
    trust_core: "CHỈ SỐ TIN CẬY (TRUST-CORE)",
    personal_info: "Thông tin cá nhân",
    edit_account_desc: "Chỉnh sửa thông tin tài khoản của bạn",
    full_name: "Họ và tên",
    email_desc: "Email không thể thay đổi",
    role: "Vai trò",
    created_at: "Ngày tạo",
    active_account: "Tài khoản đang hoạt động",
    update_language: "Cập nhật ngôn ngữ"
  },
  en: {
    settings: "Settings",
    profile: "Profile",
    password: "Password",
    notifications: "Notifications",
    appearance: "Appearance",
    language: "Language",
    save: "Save Information",
    saving: "Saving...",
    update_success: "Updated successfully!",
    analyze_now: "Analyze Now",
    analyzing: "Analyzing...",
    excellent: "EXCELLENT",
    stable: "STABLE",
    caution: "CAUTION",
    ai_verified: "AI VERIFIED",
    trust_core: "TRUST-CORE",
    personal_info: "Personal Information",
    edit_account_desc: "Edit your account information",
    full_name: "Full Name",
    email_desc: "Email cannot be changed",
    role: "Role",
    created_at: "Created At",
    active_account: "Active Account",
    update_language: "Update Language"
  }
};

export const useTranslation = (user) => {
  const lang = user?.language || 'vi';
  
  return useMemo(() => {
    return (key) => {
      return translations[lang]?.[key] || translations['vi'][key] || key;
    };
  }, [lang]);
};
